//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  Phone,
  Identity,
  MaxLength,
} from '@/utils/validatorClass.js'
import { insertOrUpdateFamily } from '@/https/prepareEnroll'
import { success } from '@/utils/notify.js'
import {
  Family2Select,
  Input,
  PolicySelect,
} from '@/constant/componentConfig'
import { cloneDeep } from '@/utils/lodash'

export default {

  props: {
    model: {
      type: Object,
      default: () => ({}),
    },
  },

  data () {
    return { familyInfo: {} }
  },

  computed: {
    renderData () {
      return [
        new Input({
          value: 'cymc',
          label: '姓名',
          required: true,
          rules: [new MaxLength('姓名', 30)],
        }),
        new Input({
          value: 'gzdw',
          label: '工作单位',
          rules: [new MaxLength('工作单位', 200)],
        }),
        new Family2Select(),
        new PolicySelect({ value: 'zzmmdm' }),
        new Input({
          value: 'cyzjhm',
          label: '证件号码',
          required: true,
          rules: [new Identity('证件号码')],
        }),
        new Input({
          value: 'lxfs',
          label: '联系方式',
          rules: [new Phone('联系方式')],
        }),
      ]
    },
  },

  watch: {
    model: {
      handler (val, oldVal) {
        if (val) {
          this.familyInfo = cloneDeep(val)
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    async save () {
      if (!await this.$refs.form.validate()) {
        return
      }

      const { code } = await insertOrUpdateFamily({ ...this.familyInfo })

      if (+code === 0) {
        success('保存成功')
        setTimeout((e) => {
          this.$emit('do-handler-success')
          this.$emit('on-back')
        }, 400)
      }
    },
  },
}
